export const formatPrice = (price: number) => {
  return (price / 100).toLocaleString("fr-FR", { style: "currency", currency: "EUR" });
};
export const formatPriceCompact = (price: number) => {
  return (price / 100).toLocaleString("fr-FR", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 0,
  });
};

/**
 *
 * @param obj
 * @returns reformat object, transforming a single level object into a deepper one.
 *  Levels in the first object are represented by the '__' character
 */
export const transformObject = (obj) => {
  const result = {};

  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const nestedKeys = key.split("__");
      let currentObj = result;

      for (let i = 0; i < nestedKeys.length; i++) {
        const nestedKey = nestedKeys[i];

        if (!Object.prototype.hasOwnProperty.call(currentObj, nestedKey)) {
          if (i === nestedKeys.length - 1) {
            currentObj[nestedKey] = obj[key];
          } else {
            currentObj[nestedKey] = {};
          }
        }

        currentObj = currentObj[nestedKey];
      }
    }
  }

  return result;
};

// General scroll to element function with 24px margin on top
export const scrollToRef = (ref) => window.scrollTo(0, ref.current?.offsetTop - 24);
